export default ['$resource', 'BASE_URL', function ($resource, BASE_URL) {
  return $resource(BASE_URL + "/users/:id/:resource/:option/:invitationId", {}, {
    invite: {method: 'POST', params: {resource: "invite"}},
    updateCurrent: {method: 'PUT', params: {resource: "language"}},
    inviteAgain: {method: 'POST', params: {resource: "invite", option: "resend"}},
    cancelInvitation: {method: 'DELETE', params: {resource: "invite"}},
    domains: {method: 'GET', isArray: true, params: {resource: "domains"}},
    active: {method: 'GET', isArray: true, params: {resource: "active"}},
    current: {method: 'GET', ignoreInterceptor: true, params: {resource: "current"}},
    touchCurrent: {method: 'PUT', ignoreInterceptor: true, params: {resource: "current"}},
    pending: {method: 'GET', isArray: true, params: {resource: "pending"}},
    stats: {method: 'GET', params: {resource: "stats"}},
    edit: {method: 'PUT'},
    enable: {method: 'PUT', params: {resource: "enable"}},
    disable: {method: 'PUT', params: {resource: "disable"}},
    working: {method: 'GET', isArray: true, params: {resource: "working"}, ignoreLoadingBar: true},
    registered: {method: 'GET', isArray: true, params: {resource: "registered"}},
    exists: {method: 'GET', params: {resource: "exists"}},
    trialExpireDate: {method: 'GET', params: {resource: "trial-expire-date"}},
    setBlockingIncomingCalls: {method: 'PUT', params: {resource: "set-blocking-incoming-calls"}},
    changeMissedIncomingCallsNotification: {method: 'PUT', params: {resource: "missed-incoming-calls-notification"}},
    editPending: {method: 'PUT', params: {resource: "pending"}}
  })
}];
